module.exports = __webpack_public_path__ + "static/media/2.35d13f98.jpg";